"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Spinner = _interopRequireDefault(require("./Spinner"));
var _Dots = _interopRequireDefault(require("./Dots"));
var _shared = require("./shared");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Return <Dots/> or <Spinner/> based on `variant?.dots`.
 * Reused in all the variants of the component.
 */const RenderActivityIndicator = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    variant = {},
    dotSize,
    size,
    color,
    indicatorBackgroundColor,
    thickness,
    label,
    isStatic
  } = _ref;
  const {
    dots,
    style
  } = variant || {};
  const isDots = dots === true || style === _shared.DOTS_STYLE;
  return isDots ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dots.default, {
    ref: ref,
    size: dotSize,
    color: color,
    indicatorBackgroundColor: indicatorBackgroundColor,
    label: label,
    isStatic: isStatic
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {
    ref: ref,
    size: size,
    color: color,
    indicatorBackgroundColor: indicatorBackgroundColor,
    thickness: thickness,
    label: label,
    isStatic: isStatic
  });
});
RenderActivityIndicator.displayName = 'RenderActivityIndicator';
RenderActivityIndicator.propTypes = {
  /**
   * ActivityIndicator variants
   * */
  variant: _propTypes.default.shape({
    dots: _propTypes.default.bool,
    style: _propTypes.default.oneOf([_shared.DOTS_STYLE])
  }),
  /**
   * Size of the dots
   * */
  dotSize: _propTypes.default.number,
  /**
   * Size of the spinner
   * */
  size: _propTypes.default.number,
  /**
   * Primary color
   * */
  color: _propTypes.default.string,
  /**
   * Secondary color (background) of the indicator
   * */
  indicatorBackgroundColor: _propTypes.default.string,
  /**
   * Thickness of the indicator
   * */
  thickness: _propTypes.default.number,
  /**
   * Label for the ActivityIndicator
   * */
  label: _propTypes.default.string,
  /**
   * if true, there's no animation for ActivityIndicator
   * */
  isStatic: _propTypes.default.bool
};
var _default = exports.default = RenderActivityIndicator;